import { orientationModuleGroupService } from '@/services/api/orientationModuleGroup.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { orientationModuleGroupModel } from '@/models/api/orientationModuleGroup.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },

    listByHeader: {},
};

export const ORIENTATION_MODULE_GROUP_MODULE = "api/orientationModuleGroup";

// ACTIONS
export const GET_ALL_ORIENTATION_MODULE_GROUP = 'getAllOrientationModuleGroup';
export const GET_ORIENTATION_MODULE_GROUP = 'getOrientationModuleGroup';
export const UPDATE_ORIENTATION_MODULE_GROUP = 'updateOrientationModuleGroup';
export const UPDATE_ORIENTATION_GROUP_SEQUENCE = 'updateOrientationGroupSequence';

// MUTATIONS
const REQUESTING = 'requesting';
const ALL_ORIENTATION_MODULE_GROUP_SUCCESS = 'allOrientationModuleGroupSuccess';
const SUCCESS = 'commonSuccess';
const FAILURE = 'commonFailure';
const GET_ORIENTATION_MODULE_GROUP_SUCCESS = 'getOrientationModuleGroupSuccess';
const SET_ORIENTATION_MODULE_GROUP_BY_HEADER = 'setOrientationModuleGroupByHeader';

export const actions = {
    [GET_ALL_ORIENTATION_MODULE_GROUP]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return orientationModuleGroupService
            .getAll(filter)
            .then((result) => {
                commit(ALL_ORIENTATION_MODULE_GROUP_SUCCESS, {data: result, filter});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [GET_ORIENTATION_MODULE_GROUP]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return orientationModuleGroupService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_ORIENTATION_MODULE_GROUP_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE_GROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return orientationModuleGroupService
            .update(data)
            .then((result) => {
                let message = i18n.t('label.updateX', [i18n.t('module.group')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_GROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_GROUP_SEQUENCE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return orientationModuleGroupService
            .updateSequence(data)
            .then((result) => {
                let message = i18n.t('label.updateX', [i18n.t('label.sequence')]);
                alertHelper.alertSuccess({message});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                commit(FAILURE);
            });
    },
}

export const mutations = {
    [ALL_ORIENTATION_MODULE_GROUP_SUCCESS](state, {data, filter}) {
        let orientationModuleGroups = data.data || [];
        state.list.data = orientationModuleGroups;
        if (data.pagination) state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);
        if(data.success) {
            state.list.data = orientationModuleGroups
                .map(item => orientationModuleGroupModel(item))
                .sort((first, second) => first.sequence - second.sequence);
        }
        if(filter?.header) {
            state.listByHeader = {
                ...state.listByHeader,
                [filter.header]: state.list.data,
            };
        }
    },
    [GET_ORIENTATION_MODULE_GROUP_SUCCESS](state, data) {
        let item = data.data;
        state.details = orientationModuleGroupModel(item);
    },
    [SET_ORIENTATION_MODULE_GROUP_BY_HEADER](state, {header, data}) {
        state.listByHeader = {
            ...state.listByHeader,
            [header]: data,
        };
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
}

